/*
 * cc-drawer-portal.js — iOS-Safari Drawer-Fix (robust, iOS-version-unabhängig)
 *
 * Problem: Menü-Drawer (#menu-drawer) und Warenkorb-Drawer (#mini-cart) liegen position:fixed
 * im Header-Teilbaum (header--cc). iOS Safari malt diesen Teilbaum unter #MainContent → Drawer
 * verschwindet hinter dem Hero. z-index hilft nicht (Context kann nicht ausbrechen); welcher
 * Vorfahr-Context greift, ist iOS-versionsabhängig (iOS 14.5 anders als iOS 16+).
 *
 * Lösung: Bei offenem Drawer das Panel an #cc-overlay-root direkt unter <body> hängen
 * (echter Root-Stacking-Context) → liegt zuverlässig über Hero UND Announcement-Bar. Beim
 * Schließen exakt an die Originalposition (Kommentar-Marker) zurück, damit die Theme-Open/
 * Close-/Toggle-Logik (im Header verbleibender <summary>/<details>) intakt bleibt.
 *
 * Open-Signale (auf <body>, via global.js HeaderDrawer/CartDrawer setClasses):
 *   Menü:      menu-mobile--open / --opening / --closing
 *   Warenkorb: mini-cart--open / --opening / --closing
 * iOS-14-kompatibel gehalten (var/function, keine privaten Felder).
 */
(function () {
  if (window.__ccDrawerPortal) return;
  window.__ccDrawerPortal = true;

  function portalRoot() {
    var r = document.getElementById('cc-overlay-root');
    if (!r) {
      r = document.createElement('div');
      r.id = 'cc-overlay-root';
      document.body.appendChild(r);
    }
    return r;
  }

  var moved = {}; // key -> { el, marker }

  function moveOut(key, selector) {
    if (moved[key]) return;
    var el = document.querySelector(selector);
    if (!el || !el.parentNode) return;
    var marker = document.createComment('cc-portal-' + key);
    el.parentNode.insertBefore(marker, el);
    portalRoot().appendChild(el);
    moved[key] = { el: el, marker: marker };

    // Warenkorb-Inhalt wird sonst lazy via IntersectionObserver geladen; der Move
    // (disconnect/reconnect des <mini-cart>-Custom-Elements) lässt das auf iOS-Safari
    // ausfallen → Panel bleibt leer/weiß. Inhalt daher explizit über den Theme-Mechanismus
    // nachladen (cart:refresh → CartDrawer.onCartRefresh befüllt #mini-cart per getElementById).
    if (key === 'cart') {
      try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    }
  }

  function moveBack(key) {
    var m = moved[key];
    if (!m) return;
    if (m.marker && m.marker.parentNode) {
      m.marker.parentNode.insertBefore(m.el, m.marker);
      m.marker.parentNode.removeChild(m.marker);
    }
    moved[key] = null;
  }

  function hasAny(list, names) {
    for (var i = 0; i < names.length; i++) {
      if (list.contains(names[i])) return true;
    }
    return false;
  }

  // Menü nur auf Mobil (<750px) reparenten. Ab 750px ist der Menü-Drawer ein Desktop-Dropdown
  // (position:absolute; top:100%) — ein Reparent würde ihn off-screen schieben (Tablet-Bug).
  function isMobileMenu() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function sync() {
    var c = document.body.classList;
    // WICHTIG: das GANZE <header-drawer> verschieben (nicht nur #menu-drawer) — sonst bricht die
    // Submenü-Mechanik (Unterkategorie öffnen → Menü verschwindet), weil das innere Panel aus
    // .menu-drawer-container gelöst wird. Als ganzes Element bleibt die Struktur intakt.
    if (isMobileMenu() && hasAny(c, ['menu-mobile--open', 'menu-mobile--opening', 'menu-mobile--closing'])) {
      moveOut('menu', 'header-drawer');
    } else {
      moveBack('menu');
    }
    if (hasAny(c, ['mini-cart--open', 'mini-cart--opening', 'mini-cart--closing'])) {
      moveOut('cart', 'cart-drawer');
    } else {
      moveBack('cart');
    }
  }

  var observer = new MutationObserver(sync);

  function start() {
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', sync); // Orientierungswechsel (Mobil↔Tablet) bei offenem Menü
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
